module.exports = __webpack_public_path__ + "static/media/dashboard2.53364a87.png";